import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap'

export const ScoreModal = ({ isOpen, toggle, handleChange, handleSave, formData, modalType }) => {
	return (
		<Modal isOpen={isOpen} toggle={toggle}>
			<ModalHeader toggle={toggle}>{modalType === 'edit' ? 'Update Score' : 'Add New Score'}</ModalHeader>
			<ModalBody>
				<Form>
					<FormGroup>
						<Label for="assdate">Date</Label>
						<Input type="date" name="assdate" id="assdate" value={formData.assdate || ''} onChange={handleChange} />
					</FormGroup>
					<FormGroup>
						<Label for="coursetest">Test</Label>
						<Input type="text" name="coursetest" id="coursetest" value={formData.coursetest || ''} onChange={handleChange} />
					</FormGroup>
					<FormGroup>
						<Label for="score">Score</Label>
						<Input type="number" name="score" id="score" step="1" value={formData.score || ''} onChange={handleChange} />
					</FormGroup>
					<FormGroup>
						<Label for="goal">Goal</Label>
						<Input type="number" name="goal" id="goal" step="1" value={formData.goal || ''} onChange={handleChange} />
					</FormGroup>
				</Form>
			</ModalBody>
			<ModalFooter>
				<Button color="secondary" onClick={toggle}>
					Close
				</Button>
				<Button color="primary" onClick={handleSave}>
					Save
				</Button>
			</ModalFooter>
		</Modal>
	)
}
